import { HeurekaElementFactory } from "../util/HeurekaElementFactory";
import type { FilterSectionLoadedEvent } from "../multifiltering/FilterTypes";
import { FilterTitleClickAction } from "./FilterTitleClickAction";
import { SubmitOnChangeListener } from "./SubmitOnChange";
import { fireFilterSubmit } from "./FilterFormActions";
import { SortingForm } from "../sorting/SortingForm";
import { events } from "../events";
import { isNotActive } from "../toggle/Toggle";

const MOBILE_FILTERS_ID = "heureka_filterTitles";

export class FilterTitles {
  private static readonly factory = HeurekaElementFactory.byId(MOBILE_FILTERS_ID, FilterTitles);

  /*               */
  constructor(readonly elem: HTMLElement) {}

  /*                  */
  static template(rootElement?: ParentNode | null) {
    return FilterTitles.factory.pick(undefined, rootElement);
  }

  /*               */

  static register() {
    events.onFilterSectionLoaded(FilterTitles.initAll);
    if (isNotActive("HEUREKA_2012_FIX_FIRST_LEVEL_FILTERS_STYLING_ON_RELOAD_ERROR")) {
      events.onFilterSectionLoadAborted(FilterTitles.initAll);
    }
  }

  static initAll(event?: FilterSectionLoadedEvent, rootElement?: ParentNode) {
    FilterTitles.template(rootElement)?.init();
  }

  protected init() {
    FilterTitleClickAction.on(this);
    SubmitOnChangeListener.on(
      this.elem,
      SubmitOnChangeListener.submitOnChange(fireFilterSubmit, SortingForm.factory.selector),
    );
    return this;
  }
}
